import { OrderInfo } from '@src/app/order-info-context';
import { deleteAsync, getAsync, patchAsync, postAsync } from './_base';
import { VariationItemModel } from '@src/components/variation-picker/VariationPicker';
import { CartModel } from '@src/app/types';

const cartApiUrl = import.meta.env.VITE_APP_API_CART_URL;
const cartCountApiUrl = import.meta.env.VITE_APP_API_CART_COUNT_URL;

interface UpdateCartRequestModel {
  quantity?: number;
  firstCollection?: string;
  schedule?: number[];
  session?: string;
  accountId?: string;
  locationId?: string;
  quantityRemaining?: number | false;
}

export interface UpdateCartPostcodeResponseModel {
  result: 'successful' | 'failed';
  message?: string;
};

export interface ApplyPromoCodeResponseAPIModel {
  success?: boolean;
  result?: boolean;
  successfully?: boolean;
  cart?: CartModel;
  error?: string;
};

export const addToCartAsync = async (body: { items: OrderInfo[]; accountId?: string; locationId?: string, selectedItem?: VariationItemModel }, full?: boolean) => {
  return postAsync(cartApiUrl, { full, accountId: body.accountId, locationId: body.locationId }, body);
};

export const updateItemAsync = async (itemId: string, body: UpdateCartRequestModel, full?: boolean) => {
  return patchAsync(cartApiUrl + '/' + itemId, { full, accountId: body.accountId, locationId: body.locationId }, body);
};

export const removeItemAsync = async (itemId: string, full?: boolean) => {
  return deleteAsync(cartApiUrl + '/' + itemId, { full }, undefined, !full);
};

export const updateCartPostcodeAsync = async (url: string, cartId: string, postcode: string) => {
  return (await patchAsync(
    url,
    {},
    {
      cartId,
      postcode,
    }
  )) as UpdateCartPostcodeResponseModel;
};

export const getCountCartItemsAsync = async () => {
  return getAsync(cartCountApiUrl);
};

export const updateCountItemsInCart = () => {
  getCountCartItemsAsync().then((data) => {
    window.localStorage.setItem('MSG_CART_QUANTITY', data);
    setTimeout(() => {
      window.dispatchEvent(new StorageEvent('storage', { key: 'MSG_CART_QUANTITY', newValue: data }));
    }, 0);
  });
};

export const postApplyPromoCodeAsync = async (apiUrl: string, promoCode: string): Promise<ApplyPromoCodeResponseAPIModel> => {
  return postAsync(apiUrl, {}, { promoCode });
};
